import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <footer>
      <p>
        ©2022 <span className="me-t ">Al Jabir</span>. All Rights Reserved
      </p>
    </footer>
  )
}

export default Footer
